import { register } from "@rill/loader";

register(
  {
    name: "athleteTeam",
    meta: ["cycle"],
    ttl: "2 hours",
  },
  async (
    { api, locals },
    {
      proxyAthlete,
      customLimit = 1,
      customSkip,
      status = "published",
      customSort = { createdDate: -1 },
      customProjection,
    }
  ) => {
    return await api("cycle", {
      query: {
        limit: false,
        createdBy: locals.activeUserToRequest._id,
        status: status,
        type: "subscription",
        "members.id": proxyAthlete,
        storeType: "teams",
        proxyAthlete,
        customLimit,
        customSkip,
        customSort,
        customProjection,
        coachId: locals.activeUserToRequest._id,
        feCycles: true,
      },
    }).then(async (cycles) => {
      return await cycles.json();
    });
  }
);

/**
 * The client's active Flexible Program, if they are on one.
 *
 * Keyed differently from `athleteTeam` on purpose. A team's master cycle is
 * owned by the COACH and members are listed on it, so `members.id` is the only
 * link to the athlete. A flexible cycle is a single document owned by the
 * CLIENT, so `owner` identifies it - but `members.id` is still the "still
 * enrolled" signal, because stopping a program (cycle-teams-stop-program) pulls
 * the client out of `members` without deleting the cycle. Querying both means a
 * stopped program stops showing while its history survives.
 *
 * Note there is deliberately no `feCycles`/`coachId`: that path forces
 * `owner === coachId`, which a flexible cycle can never satisfy.
 */
register(
  {
    name: "athleteFlexibleProgram",
    meta: ["cycle"],
    ttl: "2 hours",
  },
  async (
    { api },
    {
      proxyAthlete,
      customLimit = 1,
      customSkip,
      customSort = { createdDate: -1 },
      customProjection,
    }
  ) => {
    return await api("cycle", {
      query: {
        limit: false,
        owner: proxyAthlete,
        "members.id": proxyAthlete,
        storeType: "flexible",
        proxyAthlete,
        customLimit,
        customSkip,
        customSort,
        customProjection,
      },
    }).then(async (cycles) => {
      return await cycles.json();
    });
  }
);
